type OrderedRecipient = {
  signingOrder?: number | null;
  stakeholderType?: unknown;
};

const missingSigningOrderRank = Number.MAX_SAFE_INTEGER;

const getSigningOrderRank = (recipient: OrderedRecipient) =>
  typeof recipient.signingOrder === 'number' && Number.isFinite(recipient.signingOrder)
    ? recipient.signingOrder
    : missingSigningOrderRank;

export const orderEnvelopeRecipients = <T extends OrderedRecipient>(recipients: readonly T[]) => {
  const decoratedRecipients = recipients.map((recipient, index) => ({
    recipient,
    index,
    signingOrderRank: getSigningOrderRank(recipient),
    stakeholderType: String(recipient.stakeholderType ?? ''),
  }));

  const firstTypeIndexBySigningOrder = new Map<string, number>();

  decoratedRecipients.forEach(({ signingOrderRank, stakeholderType, index }) => {
    const key = `${signingOrderRank}:${stakeholderType}`;

    if (!firstTypeIndexBySigningOrder.has(key)) {
      firstTypeIndexBySigningOrder.set(key, index);
    }
  });

  return [...decoratedRecipients]
    .sort((left, right) => {
      if (left.signingOrderRank !== right.signingOrderRank) {
        return left.signingOrderRank - right.signingOrderRank;
      }

      const leftTypeIndex =
        firstTypeIndexBySigningOrder.get(`${left.signingOrderRank}:${left.stakeholderType}`) ??
        left.index;
      const rightTypeIndex =
        firstTypeIndexBySigningOrder.get(`${right.signingOrderRank}:${right.stakeholderType}`) ??
        right.index;

      if (leftTypeIndex !== rightTypeIndex) {
        return leftTypeIndex - rightTypeIndex;
      }

      return left.index - right.index;
    })
    .map(({ recipient }) => recipient);
};
